// Demo video sound (2026-09-29, product decision: "volume should be off by
// default; when the user turns it on it plays with sound"). Every demo
// player starts MUTED; sound only comes on when the viewer turns it on --
// the "Sound on" button (unmuteNow) or the video's own volume control.
// Nothing is remembered between visits, so it's always off by default.

export function playPreferSound(v) {
  if (!v) return;
  v.muted = true;
  v.play().catch(() => {});
}

// Kept for existing onVolumeChange wiring -- no longer persists anything.
export function rememberMuteChoice() {}

export function unmuteNow(v) {
  if (!v) return;
  v.muted = false;
  if (v.volume < 0.5) v.volume = 0.8;
  if (v.paused) v.play().catch(() => {});
}
